import { Flex } from '@mantine/core';
import { PropsWithChildren } from 'react';
import styles from './styles.module.css';

export type MetricWrapperProps = {
	onClick: () => void;
	active: boolean;
	clickable: boolean;
};

export function MetricWrapper({
	onClick,
	active,
	children,
	clickable,
}: PropsWithChildren<MetricWrapperProps>) {
	return (
		<Flex
			direction="column"
			gap="4px"
			className={styles.wrapper}
			justify="space-between"
			onClick={onClick}
			data-clickable={clickable}
			data-active={clickable && active}
		>
			{children}
		</Flex>
	);
}
